// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"2658f791","149":"37ae8782","215":"f75edb76","264":"a0c70d0d","423":"5647d8f0","588":"b8e18658","638":"33e7b0da","696":"af81b84c"}[chunkId] + ".chunk.js";
};